export const AUTH_ERROR = 'AUTH_ERROR';

export const requireLogin = () => {
  let thisUrl = window.location.href;
  window.location.href = process.env.REACT_APP_DELEEVADMIN + '/account/login?next=' + encodeURIComponent(thisUrl);
};
